/*
  PS Cart helper — shared add-to-cart for all Purely Sourced custom sections/snippets.

  Adds items via /cart/add.js using Shopify's bundled section rendering, then hands
  the fresh HTML to Dawn's <cart-drawer> (or <cart-notification>) renderContents(),
  which swaps in the updated line items and opens the drawer — no page reload.

  Falls back to a full reload when the drawer element or the Section Rendering
  response is unavailable, so behaviour degrades to the old flow, never worse.

  Usage:
    PSCart.add({ items: [{ id: 123, quantity: 1 }] })      // JSON payload
    PSCart.add(new FormData(formElement))                  // form payload
  Returns a Promise that resolves with the cart response, or rejects with an
  Error whose .data carries Shopify's error payload (e.g. sold-out 422s).
*/
(function () {
  'use strict';

  function cartElement() {
    return document.querySelector('cart-drawer') || document.querySelector('cart-notification');
  }

  function sectionIds() {
    var el = cartElement();
    if (!el || typeof el.getSectionsToRender !== 'function') return null;
    try {
      return el.getSectionsToRender().map(function (s) { return s.id; });
    } catch (e) {
      return null;
    }
  }

  function add(payload) {
    var ids = sectionIds();
    var config = { method: 'POST', headers: { Accept: 'application/javascript' } };

    if (payload instanceof FormData) {
      if (ids) {
        payload.append('sections', ids.join(','));
        payload.append('sections_url', window.location.pathname);
      }
      config.body = payload;
    } else {
      var body = payload || {};
      if (ids) {
        body.sections = ids;
        body.sections_url = window.location.pathname;
      }
      config.headers['Content-Type'] = 'application/json';
      config.body = JSON.stringify(body);
    }

    return fetch(window.Shopify.routes.root + 'cart/add.js', config).then(function (response) {
      return response.json().then(function (data) {
        if (!response.ok || data.status) {
          var err = new Error((data && (data.description || data.message)) || 'Could not add to cart');
          err.data = data;
          throw err;
        }

        var el = cartElement();
        if (el && data.sections && typeof el.renderContents === 'function') {
          el.renderContents(data);
          // The cart-drawer upsell markup arrives inert (scripts inside injected
          // HTML never execute), so re-run its initialiser if it's on the page.
          if (typeof window.psUpsellInit === 'function') {
            setTimeout(window.psUpsellInit, 0);
          }
        } else {
          window.location.reload();
        }
        return data;
      });
    });
  }

  window.PSCart = { add: add };
})();
